import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import OddsBoostComponent from './OddsBoostComponent';
import commonDataStore from '~shared/components/react/CommonDataListEvents/commonDataListEvents';
import {
    ODDS_BOOST_LOCATIONS,
} from '../constants';
import './styles/oddsBoostWidget.scss';

const OddsBoostWidget = ({
  source = '',
  isFavouriteSport = false,
  sportSlug = '',
  oddsBoostLocation = ODDS_BOOST_LOCATIONS.HOMEPAGE_WIDGET,
}) => {

    return (
        <Provider store={commonDataStore}>
            <OddsBoostComponent
                source={source}
                sportSlug={sportSlug}
                isFavouriteSport={isFavouriteSport}
                oddsBoostLocation={oddsBoostLocation}
            />
        </Provider>
    );
};

OddsBoostWidget.propTypes = {
    source: PropTypes.string,
    isFavouriteSport: PropTypes.bool,
    sportSlug: PropTypes.string,
    oddsBoostLocation: PropTypes.number,
};

export default OddsBoostWidget;
